
const getCardService = (actionCallback, state) => {
    let token = "Token " + localStorage.getItem('token')
    let baseUrl= localStorage.getItem('serviceUrl')

    fetch(baseUrl +"/rest/card/getCards" + "/?Authorization=" + token, {
        method: "POST",
        headers: {
            'content-type': 'application/json',
            'Authorization': token,
            
        },
        body: JSON.stringify(state)
    })
        .then(res => {
            if (res.status === 200 || res.status === 201  || res.status === 304) {
                res.json().then(json => actionCallback(json, "success"))
            }
            else if(res.status === 204){
               let data="No cards for this user."
                actionCallback(data,"emptyBody")
            }
             else if (res.status === 401) {
           
            //     localStorage.clear();
            //     this.props.history.push("/")
            let errorOut= "logout"
            actionCallback(errorOut)
            this.props.history.push('/SessionOut')
            }
            else{
                 // res.json().then(json => actionCallback(json, "error"))
            }
        })
}

export default getCardService;


// WEBPACK FOOTER //
// ./src/services/components/get_card.jsx